import { Button, Layout, message, Row, Spin, Typography } from "antd";
import dayjs from "dayjs";
import isEmpty from "lodash/isEmpty";
//import uniqBy from "lodash/uniqBy";
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFilePicker } from "use-file-picker";
import ArrowChatIcon from "../../../assets/icons/arrow-chat.svg";
import AvatarComponent from "../../../components/AvatarComponent";
import ConversationThreeDotsModalComponent from "../../../components/ConversationThreeDotsModalComponent";
import FanAvatarComponent from "../../../components/FanAvatarComponent";
import FanRequireSubscribeModalComponent from "../../../components/FanRequireSubscribeModalComponent";
import IncomeMessageComponent from "../../../components/IncomeMessageItemComponent";
import MessageInputComponent from "../../../components/MessageInputComponent";
import MessageMediaItemComponent from "../../../components/MessageMediaItemComponent";
import MessageTextItemComponent from "../../../components/MessageTextItemComponent";
import AudioMessageComponent from "../../../components/AudioMessageComponent/AudioMessageComponent";
import AudioPrivateComponent from "../../../components/AudioPrivateComponent/AudioPrivateComponent";
import AudioMediaItemComponent from "../../../components/AudioMediaItemComponent/AudioMediaItemComponent";
import RecordAudioModal from "../../../components/RecordAudioModal/RecordAudioModal";
import ShareModalComponent from "../../../components/ShareModalComponent";
import SpinnerComponent from "../../../components/SpinnerComponent/SpinnerComponent";
import ThreeDotsComponent from "../../../components/ThreeDotsComponent";
import VerifiedUserIconComponent from "../../../components/VerifiedUserIconComponent/VerifiyedUserIconComponent";
import {
  ACCEPTED,
  CONVERSATION_DATE_FORMAT,
  F_CURRENT_TAB,
  FAN,
  FILE,
  PENDING,
  REJECTED,
  REQUEST_LOADING_STATES,
  TEXT,
} from "../../../helpers/constant";
import { usePreviousLocationContext } from "../../../helpers/PreviousLocationContext";
import { IConversations, IMessage } from "../../../helpers/types";
import {
  addMessageInstant,
  findAllMessagesByConversationId,
  getConversationById,
  readAllMessages,
  readAllMessagesInConversation,
  resetSelectedConversation,
  sendMessage,
} from "../../../redux/messages/messagesSlice";
import { AppDispatch, StoreState } from "../../../redux/store";
import { authService, fileService, messageService, userService } from "../../../services";
import { socket } from "../../../socket";
import "./index.less";

const FanRequestMediaPage = () => {
  const { conversationId } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const previousLocation = usePreviousLocationContext();
  const selectedConversation = useSelector((state: StoreState) => state.messages.selectedConversation);
  const messageData = useSelector((state: StoreState) =>
    state.messages.messagesData.find((conversation) => conversation.conversationId === conversationId)
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const messagesContainerRef = useRef<HTMLDivElement>(null);
  const topSentinelRef = useRef<HTMLDivElement>(null);
  const bottomSentinelRef = useRef<HTMLDivElement>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const loadingMore = useSelector((state: StoreState) => state.messages.findAllMessagesByConversationIdLoading);
  const fromPayment = sessionStorage.getItem("payment-page") === "True";
  // Refs to avoid stale closures in observers/callbacks
  const loadingRef = useRef<boolean>(false);
  const pageRef = useRef<number>(messageData?.page ? messageData.page : 1);
  const hasMoreRef = useRef<boolean>(true);
  // Scroll position preservation refs
  const scrollAnchorRef = useRef<{ height: number; top: number; offset: number } | null>(null);
  const isUserAtBottomRef = useRef<boolean>(true);
  const preventScrollUpdateRef = useRef<boolean>(false);
  const didInitialScrollRef = useRef<boolean>(false);
  const { unreadConversations } = useSelector((state: StoreState) => state.messages);
  type LoadOpts = { initial?: boolean; prepend?: boolean };
  const currentUser = useMemo(
    () => ({
      role: authService.getRole(),
      userId: authService.getId(),
    }),
    []
  );
  const shouldFetch = useRef(true);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState<number>(0);
  const messages = messageData?.messages || [];
  const [isConversationStep, setIsConversationStep] = useState<boolean>((messageData && messageData?.messages.length > 0) || true);
  //const [subscriptionLoading, setSubscriptionLoading] = useState(true);
  const [openFileSelector, { plainFiles, clear }] = useFilePicker({
    readAs: "ArrayBuffer",
    multiple: false,
    accept: ["image/*", "video/*", "audio/*"],
    limitFilesConfig: { max: 1 },
  });
  const [isRequireSubscribeModalOpen, setIsRequireSubscribeModalOpen] = useState<boolean>(false);
  const [isThreeDotsModalOpen, setIsThreeDotsModalOpen] = useState<boolean>(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState<boolean>(false);
  const [showAudioModal, setShowAudioModal] = useState<boolean>(false);
  const location = useLocation();
  let hasNextPage;
  if (!messageData) {
    hasNextPage = true;
  } else {
    hasNextPage = messageData.messages.length > 0 && messageData?.page < messageData?.totalPages;
  }
  useEffect(() => {
    if (shouldFetch.current) {
      shouldFetch.current = false;
      if (conversationId) {
        dispatch(readAllMessages(conversationId));
      }
      dispatch(readAllMessagesInConversation({ conversationId, conversationType: window.localStorage.getItem(F_CURRENT_TAB) }));
      if ((isEmpty(selectedConversation) && conversationId !== undefined) || (fromPayment && conversationId !== undefined)) {
        dispatch(getConversationById(conversationId));
      }
      // if (!isEmpty(selectedConversation)) {
      //   if (selectedConversation?.interlocutor?.chat !== "free") {
      //     //updateSubscription();
      //   }
      // } else {
      //   if (conversationId !== undefined) {
      //     dispatch(getConversationById(conversationId));
      //   }
      // }
    }
  }, []);

  // Stable scroll positioning without forced re-renders
  const preserveScrollPosition = useCallback(() => {
    const el = messagesContainerRef.current;
    if (!el || preventScrollUpdateRef.current) return;

    if (scrollAnchorRef.current !== null) {
      // Use immediate scroll adjustment
      requestAnimationFrame(() => {
        if (!el || scrollAnchorRef.current === null) return;

        const newScrollHeight = el.scrollHeight;
        const heightDifference = newScrollHeight - scrollAnchorRef.current.height;

        // Set scroll position to maintain the same view the user was seeing
        el.scrollTop = scrollAnchorRef.current.top + heightDifference;

        // Clear the scroll anchor reference
        scrollAnchorRef.current = null;
      });
    } else if (isUserAtBottomRef.current) {
      // Only scroll to bottom if user was already at bottom
      requestAnimationFrame(() => {
        if (!el) return;
        const target = Math.max(0, el.scrollHeight - el.clientHeight);
        el.scrollTop = target;
      });
    }
  }, []);

  const scrollToBottom = useCallback(() => {
    const el = messagesContainerRef.current;
    if (!el) return;
    preventScrollUpdateRef.current = true;
    requestAnimationFrame(() => {
      const target = Math.max(0, el.scrollHeight - el.clientHeight);
      el.scrollTop = target;
      isUserAtBottomRef.current = true;
      didInitialScrollRef.current = true;
      preventScrollUpdateRef.current = false;
    });
  }, []);

  // Only handle scroll position changes, not forced scrolls
  useLayoutEffect(() => {
    if (!didInitialScrollRef.current && messages.length > 0) {
      scrollToBottom();
      return;
    }
    preserveScrollPosition();
  }, [messages.length, scrollToBottom, preserveScrollPosition]);

  const loadMessages = useCallback(
    async (pageNum: number, opts: LoadOpts = {}) => {
      if (loadingRef.current) return;
      loadingRef.current = true;
      setLoading(true);

      const container = messagesContainerRef.current;
      try {
        if (opts.prepend && container) {
          // Add a class to prevent visible scroll changes
          container.classList.add("scroll-lock");

          // Store current scroll anchor before loading new content
          const oldScrollHeight = container.scrollHeight;
          const oldScrollTop = container.scrollTop;
          scrollAnchorRef.current = {
            height: oldScrollHeight,
            top: oldScrollTop,
            offset: oldScrollHeight - oldScrollTop,
          };
        }

        if (hasNextPage) {
          await dispatch(findAllMessagesByConversationId({ conversationId: conversationId!, page: pageNum }));
        }

        // Ensure we remove the scroll-lock class immediately after loading
        if (container && opts.prepend) {
          // Use requestAnimationFrame to ensure the DOM has updated
          requestAnimationFrame(() => {
            if (scrollAnchorRef.current !== null) {
              const newScrollHeight = container.scrollHeight;
              const heightDifference = newScrollHeight - scrollAnchorRef.current.height;
              container.scrollTop = scrollAnchorRef.current.top + heightDifference;
            }
            // Always remove the scroll-lock class
            container.classList.remove("scroll-lock");
          });
        }

        setLoading(false);
        loadingRef.current = false;
      } catch (error) {
        console.error("Error loading messages:", error);
        // Ensure we remove the scroll-lock class even if there's an error
        if (container) {
          container.classList.remove("scroll-lock");
        }
        setLoading(false);
        loadingRef.current = false;
      }
    },
    [conversationId, dispatch, hasNextPage]
  );

  const handleScroll = useCallback(() => {
    const container = messagesContainerRef.current;
    if (!container || preventScrollUpdateRef.current) return;

    if (container.scrollTop < 0) {
      container.scrollTop = 0;
    }

    const distanceFromBottom = container.scrollHeight - (container.scrollTop + container.clientHeight);
    isUserAtBottomRef.current = distanceFromBottom <= 100;
  }, []);

  useEffect(() => {
    loadingRef.current = loading;
  }, [loading]);

  useEffect(() => {
    if (messageData) {
      pageRef.current = messageData.page + 1;
    }
  }, [messageData]);

  useEffect(() => {
    hasMoreRef.current = hasMore;
  }, [hasMore]);

  // Track scroll position to determine if user is at bottom

  useEffect(() => {
    const root = messagesContainerRef.current;
    const sentinel = topSentinelRef.current;
    if (!root || !sentinel || loading || !hasMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !loadingRef.current && hasMoreRef.current) {
          loadMessages(pageRef.current, { prepend: true });
        }
      },
      {
        root,
        threshold: 0,
        rootMargin: "50px 0px 0px 0px",
      }
    );

    observer.observe(sentinel);
    observerRef.current = observer;

    return () => {
      observer.disconnect();
      observerRef.current = null;
    };
  }, [loading, hasMore, loadMessages]);

  // useEffect(() => {
  //   if (isEmpty(messageData)) {
  //     dispatch(findAllMessagesByConversationId({ conversationId: conversationId!, page }));
  //   }
  // }, [messageData]);

  useEffect(() => {
    function onProgressUpdate(data: number) {
      setProgress((prev) => {
        const prog = prev + 1;
        if (prog <= 99) {
          return prog;
        }
        return prev;
      });
    }

    socket.on("progress-update", onProgressUpdate);

    return () => {
      socket.off("progress-update", onProgressUpdate);
    };
  }, []);

  useEffect(() => {
    if (!isEmpty(plainFiles)) {
      const file = plainFiles[0];
      const isAudioFile =
        file.type.startsWith("audio/") || [".mp3", ".wav", ".m4a", ".ogg", ".aac", ".webm"].some((ext) => file.name.toLowerCase().endsWith(ext));

      // Only set global loading for non-audio files
      if (!isAudioFile) {
        setIsLoading(true);
      }

      const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      let newMessage: IMessage = {
        temp_id: tempId,
        conversationId: conversationId,
        type: FILE,
        uploading: true,
        medias: [],
      };

      // Mark as audio file if it's an audio file
      if (isAudioFile) {
        (newMessage as any).isAudioFile = true;
      }

      dispatch(addMessageInstant(newMessage));
      const formData = new FormData();
      formData.append("media", file);
      formData.append("temp_id", tempId);

      if (isAudioFile) {
        formData.append("isAudio", "true");
      }

      fileService
        .uploadMedia(formData, setProgress)
        .then((uploadedFile) => {
          const updatedMessage: IMessage = {
            ...newMessage,
            medias: [
              {
                fileId: uploadedFile._id !== undefined ? uploadedFile._id : "",
                isPrivate: false,
              },
            ],
            uploading: false,
          };

          // Keep the audio file flag
          if (isAudioFile) {
            (updatedMessage as any).isAudioFile = true;
          }

          dispatch(sendMessage(updatedMessage));
          clear();

          // Only clear global loading for non-audio files
          if (!isAudioFile) {
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          message.error("Something went wrong, could not send file !");

          // Clear global loading on error for non-audio files
          if (!isAudioFile) {
            setIsLoading(false);
          }
        });
    }
  }, [plainFiles]);

  const sendMessageClicked = (newMessage: string) => {
    if (isEmpty(newMessage)) return;
    const messageToSend: IMessage = {
      temp_id: `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      conversationId: conversationId,
      type: TEXT,
      text: newMessage,
    };

    dispatch(addMessageInstant(messageToSend));

    // Send message via REST API
    dispatch(sendMessage(messageToSend))
      .unwrap()
      .then(() => {
        // Message sent successfully
      })
      .catch(() => {
        message.error("Something went wrong, could not send message!");
      });
  };

  function handleConversationCreated(data: IConversations) {
    dispatch({
      type: getConversationById.fulfilled.type,
      payload: data,
    });
    navigate(`/fan/requestMedia/${data._id}`, { replace: true });
    dispatch(findAllMessagesByConversationId({ conversationId: data._id, page: pageRef.current }));

    window.location.reload();
  }

  useEffect(() => {
    // if (selectedConversation?.interlocutor?.chat !== "free") {
    //   updateSubscription();
    // }
    socket.on("conversation-created", handleConversationCreated);

    return () => {
      socket.off("conversation-created", handleConversationCreated);
    };
  }, [selectedConversation]);

  function handleSendMedia() {
    openFileSelector();
  }

  // Handle audio recording
  const handleAudioRecorded = (audioBlob: Blob, audioTitle: string) => {
    const audioFile = new File([audioBlob], `${audioTitle || "audio_recording"}.webm`, { type: "audio/webm;codecs=opus" });
    const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

    const newMessage: IMessage = {
      temp_id: tempId,
      conversationId: String(conversationId),
      type: FILE,
      uploading: true,
      medias: [],
    };

    (newMessage as any).isAudioFile = true;
    dispatch(addMessageInstant(newMessage));

    const formData = new FormData();
    formData.append("media", audioFile);
    formData.append("temp_id", tempId);
    formData.append("isAudio", "true");

    fileService
      .uploadMedia(formData, setProgress)
      .then((file) => {
        const updatedMessage: IMessage = {
          ...newMessage,
          medias: [
            {
              fileId: file._id !== undefined ? file._id : "",
              isPrivate: false,
            },
          ],
          uploading: false,
        };

        (updatedMessage as any).isAudioFile = true;
        dispatch(sendMessage(updatedMessage));

        // Ensure it's marked as accepted on the server
        if (updatedMessage._id) {
          messageService
            .updateMessageStatus({
              messageId: updatedMessage._id,
              action: "accepted",
              userType: FAN,
            })
            .catch((err) => console.error("Error setting audio message as accepted:", err));
        }
      })
      .catch((error) => {
        console.error("Audio upload error:", error);
        message.error("Something went wrong, could not send audio file!");

        const errorMessage: IMessage = {
          ...newMessage,
          uploading: false,
        };
        dispatch(sendMessage(errorMessage));
      });

    setShowAudioModal(false);
  };

  const requestMediaButtonClicked = () => {
    const isSubscribed = selectedConversation?.isFanSubscribed && new Date(selectedConversation.isFanSubscribed) > new Date();
    if (isSubscribed) {
      setIsConversationStep(true);
    } else {
      setIsRequireSubscribeModalOpen(true);
    }
  };

  const renderFooterComponent = () => {
    if (isConversationStep) {
      if (!selectedConversation?.interlocutor?.chat) return <></>;
      const isSubscribed = selectedConversation?.isFanSubscribed && new Date(selectedConversation.isFanSubscribed) > new Date();
      if (isSubscribed || selectedConversation?.interlocutor?.chat === "free") {
        return (
          <Row className="message-input-row">
            <MessageInputComponent onSendClick={sendMessageClicked} onMediaClick={handleSendMedia} hideScripts={true} hideAudio={true} />
          </Row>
        );
      } else {
        return (
          <div className={"d-flex justify-content-center"} onClick={requestMediaButtonClicked}>
            <Button className="request-media-button">{t("request-private-media")}</Button>
          </div>
        );
      }
    } else {
      const isSubscribed = selectedConversation?.isFanSubscribed && new Date(selectedConversation.isFanSubscribed) > new Date();
      if (!isSubscribed) {
        return (
          <div className={"d-flex justify-content-center"} onClick={requestMediaButtonClicked}>
            <Button className="request-media-button">{t("request-private-media")}</Button>
          </div>
        );
      }
    }
    return null;
  };

  const acceptMessage = (msg: IMessage) => {
    if (msg.mediaPushPrice?.price !== undefined) {
      if (msg.mediaPushPrice?.price === 0) {
        messageService
          .updateMessageStatus({ messageId: msg._id!, action: ACCEPTED, userType: FAN, isToDeliverMedia: true })
          .catch((err) => message.error(err || "accept-failed"));
      } else {
        navigate(
          `/fan/payment?creatorId=${msg.senderId}&type=mediaPush&mediaPushId=${msg.mediaPushId}&messageId=${msg._id}&redirectUrl=fan/requestMedia/${selectedConversation?._id}`
        );
      }
    }
  };

  const rejectMessage = (messageId: string) => {
    messageService.updateMessageStatus({ messageId, action: REJECTED, userType: FAN }).catch((err) => message.error(err || "reject-failed"));
  };

  const goToSubscriptionPage = () => {
    let url = location.pathname.substring(1);
    const param = url.split("/")[2];
    if (param === "new") {
      url = url + `?newConversation=${JSON.stringify(selectedConversation)}`;
    }
    navigate(`/common/subscribe/${selectedConversation?.interlocutor?.userId}?redirectUrl=${url}`);
  };

  function onPrivateGalleryClick() {
    let receiverId: string;
    let senderId: string;
    if (selectedConversation?.interlocutor?.role === FAN) {
      receiverId = selectedConversation?.interlocutor?.userId !== undefined ? selectedConversation?.interlocutor?.userId : "";
      senderId = currentUser?.userId !== undefined ? currentUser?.userId : "";
    } else {
      receiverId = currentUser?.userId !== undefined ? currentUser?.userId : "";
      senderId = selectedConversation?.interlocutor?.userId !== undefined ? selectedConversation?.interlocutor?.userId : "";
    }
    navigate(`/common/privateGallery?conversationId=${selectedConversation?._id}&shouldAddWatermark=true`);
  }
  const handleNavigation = () => {
    const { activeKey } = location.state || {};
    if (previousLocation?.pathname !== undefined && previousLocation?.pathname.includes("/p/")) {
      dispatch(resetSelectedConversation());
      navigate(-1);
    } else {
      navigate("/fan/message", { state: { activeKey } });
    }
  };

  const onShareProfileClick = () => {
    setIsThreeDotsModalOpen(false);
    setIsShareModalOpen(true);
  };

  const goToProfilePage = () => {
    if (selectedConversation?.interlocutor?.name !== "user-not-found") {
      navigate(`/p/${selectedConversation?.interlocutor?.username}`);
    }
  };

  useEffect(() => {
    return () => {
      const container = messagesContainerRef.current;
      if (container) {
        container.classList.remove("scroll-lock");
      }
    };
  }, []);

  // Debug audio modal state changes
  useEffect(() => {
    console.log("Audio modal state changed:", showAudioModal);
  }, [showAudioModal]);

  return (
    <Spin spinning={isLoading} style={{ maxHeight: "100%" }} indicator={<SpinnerComponent progress={true} progressValue={progress} />}>
      <Layout className="fan-message-test-container">
        <Layout.Header className="header-chat">
          <div className="header-chat-row">
            <div className="messagerie-header-icon" onClick={handleNavigation}>
              <img width={11} src={ArrowChatIcon} alt="Twizz messages" />
              {unreadConversations > 0 && (
                <Typography.Text className={`notif-message-conv`}>{unreadConversations > 99 ? "99+" : unreadConversations}</Typography.Text>
              )}
            </div>
            <div className="header-content">
              {selectedConversation?.interlocutor?.avatar ? (
                <AvatarComponent image={selectedConversation?.interlocutor?.avatar} size={35} onClick={goToProfilePage} />
              ) : (
                <FanAvatarComponent name={selectedConversation?.interlocutor?.name} size={35} />
              )}
              <div className="header-text-wrapper cursor-pointer" onClick={goToProfilePage}>
                <Typography.Text className="title-name-messagerie-header text-white-color">
                  {selectedConversation?.interlocutor?.name === "user-not-found" ? t("user-not-found") : selectedConversation?.interlocutor?.name}
                </Typography.Text>
                <VerifiedUserIconComponent
                  userId={selectedConversation?.interlocutor?.userId}
                  verified={selectedConversation?.interlocutor?.isVerified}
                  fetch={false}
                />
                {(() => {
                  const isSubscribed = selectedConversation?.isFanSubscribed && new Date(selectedConversation.isFanSubscribed) > new Date();
                  return (
                    selectedConversation?.isFanSubscribed !== null &&
                    !isSubscribed &&
                    selectedConversation?.interlocutor?.name === "user-not-found" && (
                      <Button className="fanRequestMediaSubscribeBtn">{t("subscribe")}</Button>
                    )
                  );
                })()}
              </div>
            </div>
            <div className="three-dots-component">
              <ThreeDotsComponent onClick={() => setIsThreeDotsModalOpen(true)} />
            </div>
          </div>
        </Layout.Header>
        <Layout.Content className={`content fanRequestMediaWrapper background-transparent ${loading && "loading"}`}>
          {loadingMore === REQUEST_LOADING_STATES.PENDING && (
            <div
              style={{
                position: "absolute",
                top: "80px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10,
                backgroundColor: "rgba(0, 0, 0, 0)",
                borderRadius: "50%",
                padding: "5px",
              }}
            >
              <SpinnerComponent size={20} />
            </div>
          )}
          {isConversationStep && (
            <div className="messages-container" ref={messagesContainerRef} onScroll={handleScroll}>
              <div
                ref={topSentinelRef}
                style={{ height: "1px", width: "100%", pointerEvents: "none", opacity: 0, margin: 0, padding: 0, alignSelf: "stretch" }}
              />
              {messages?.map((message, index) => {
                const isIncome = message.receiverId === currentUser?.userId;
                const messageDate = dayjs(message.createdAt);
                const showDate = index === 0 || messageDate.diff(dayjs(messages[index - 1].createdAt), "hour") >= 1;
                return (
                  <React.Fragment key={message._id || message.temp_id}>
                    {showDate && (
                      <Row className="justify-content-center mt-10 mb-10">
                        <Typography.Text className="messageDateLabel">{messageDate.format(CONVERSATION_DATE_FORMAT)}</Typography.Text>
                      </Row>
                    )}
                    <Row id={message._id} className={isIncome ? "justify-content-start" : "justify-content-end"}>
                      {message.type === TEXT && !isIncome && <MessageTextItemComponent message={message} userRole={currentUser?.role} />}
                      {message.type === FILE && !isIncome && (
                        <>
                          {/* Audio message handling */}
                          {/* Helper function to check if a media item is audio */}
                          {(() => {
                            // Check if message contains any audio media
                            const hasAudioMedia =
                              message.medias &&
                              message.medias.length === 1 &&
                              !message.mediaPushPrice &&
                              message.medias.some((media) => {
                                return (
                                  media.isAudio === true ||
                                  media.url?.toLowerCase().includes(".mp3") ||
                                  media.url?.toLowerCase().includes(".wav") ||
                                  media.url?.toLowerCase().includes(".m4a") ||
                                  media.url?.toLowerCase().includes(".ogg") ||
                                  media.url?.toLowerCase().includes(".aac") ||
                                  media.url?.toLowerCase().includes(".webm") ||
                                  media.url?.toLowerCase().includes("audio/") ||
                                  media.url?.toLowerCase().includes("audio%2f")
                                );
                              });

                            // Check if message is an audio message
                            const isAudioMessage = hasAudioMedia || (message as any).isAudioFile;

                            if (isAudioMessage) {
                              // If it has mediaPushPrice, treat as premium audio (regardless of other media types)

                              return (
                                <AudioMessageComponent
                                  audioFile={{
                                    _id: message._id || (message.medias && message.medias[0] ? message.medias[0].fileId : ""),
                                    absolutePath: message.medias && message.medias[0] && message.medias[0].url ? message.medias[0].url : "",
                                    name: message.medias && message.medias[0] ? message.medias[0].name || "audio" : "audio",
                                  }}
                                  isOwn={true}
                                  date={dayjs(message.createdAt).format("HH:mm")}
                                  isProcessing={message.uploading || (message as any).isProcessing}
                                  isRead={message.isRead || false}
                                />
                              );
                            } else {
                              // Not an audio message, render as regular media
                              return <MessageMediaItemComponent message={message} hideStatus={true} isBlur={false} income={false} />;
                            }
                          })()}
                        </>
                      )}
                      {isIncome &&
                        // Use the same approach for incoming messages
                        (() => {
                          // Check if message contains any audio media
                          const hasAudioMedia =
                            message.medias &&
                            message.medias.length === 1 &&
                            !message.mediaPushPrice &&
                            message.medias.some((media) => {
                              return (
                                media.isAudio === true ||
                                media.url?.toLowerCase().includes(".mp3") ||
                                media.url?.toLowerCase().includes(".wav") ||
                                media.url?.toLowerCase().includes(".m4a") ||
                                media.url?.toLowerCase().includes(".ogg") ||
                                media.url?.toLowerCase().includes(".aac") ||
                                media.url?.toLowerCase().includes(".webm") ||
                                media.url?.toLowerCase().includes("audio/") ||
                                media.url?.toLowerCase().includes("audio%2f")
                              );
                            });

                          // Check if message is an audio message
                          const isAudioMessage = hasAudioMedia || (message as any).isAudioFile;

                          if (isAudioMessage) {
                            // If it has mediaPushPrice, treat as premium audio (regardless of other media types)

                            return (
                              <div className="incomeMessage">
                                {selectedConversation?.interlocutor?.avatar && (
                                  <AvatarComponent image={selectedConversation.interlocutor.avatar} size={23} />
                                )}
                                <AudioMessageComponent
                                  audioFile={{
                                    _id: message._id || (message.medias && message.medias[0] ? message.medias[0].fileId : ""),
                                    absolutePath: message.medias && message.medias[0] ? message.medias[0].url : "",
                                    name: message.medias && message.medias[0] ? message.medias[0].name || "audio" : "audio",
                                  }}
                                  isOwn={false}
                                  date={dayjs(message.createdAt).format("HH:mm")}
                                />
                              </div>
                            );
                          } else {
                            // Not an audio message, render as regular message
                            return (
                              <IncomeMessageComponent
                                message={message}
                                user={selectedConversation?.interlocutor?.avatar}
                                userRole={currentUser?.role}
                                acceptMessage={acceptMessage}
                                rejectMessage={rejectMessage}
                                hideStatus={message.type === FILE && selectedConversation?.interlocutor?.role === "creator"}
                              />
                            );
                          }
                        })()}
                    </Row>
                  </React.Fragment>
                );
              })}
              <div
                ref={bottomSentinelRef}
                style={{ height: "1px", width: "100%", pointerEvents: "none", opacity: 0, margin: 0, padding: 0, alignSelf: "stretch" }}
              />
            </div>
          )}
          {selectedConversation?.interlocutor?.name === "user-not-found" ? "" : renderFooterComponent()}
          <FanRequireSubscribeModalComponent
            isOpen={isRequireSubscribeModalOpen && selectedConversation?.interlocutor?.name !== "user-not-found"}
            onClose={() => setIsRequireSubscribeModalOpen(false)}
            onSubmit={goToSubscriptionPage}
            creatorName={selectedConversation?.interlocutor?.name}
          />
          <ConversationThreeDotsModalComponent
            isOpen={isThreeDotsModalOpen}
            onClose={() => setIsThreeDotsModalOpen(false)}
            onPrivateGalleryClick={onPrivateGalleryClick}
            onShareProfileClick={onShareProfileClick}
            hideShareButton={selectedConversation?.interlocutor?.name === "user-not-found"}
            hideCancelSubButton={true}
          />
          <ShareModalComponent
            isOpen={isShareModalOpen && selectedConversation?.interlocutor?.name !== "user-not-found"}
            onClose={() => setIsShareModalOpen(false)}
            id={selectedConversation?.interlocutor?.userId}
            username={selectedConversation?.interlocutor?.username}
          />
        </Layout.Content>

        {/* Move RecordAudioModal outside Layout.Content to avoid z-index issues */}
        <RecordAudioModal
          isOpen={showAudioModal}
          onClose={() => {
            console.log("Closing audio modal");
            setShowAudioModal(false);
          }}
          onAudioReady={(audioBlob, audioTitle) => {
            console.log("Audio recorded:", audioBlob, audioTitle);
            handleAudioRecorded(audioBlob, audioTitle);
          }}
          isFromConv={true}
        />
      </Layout>
    </Spin>
  );
};

export default FanRequestMediaPage;
